(ns motorsaif.url
  (:require
   [motorsaif.string :refer [format]]
   [motorsaif.vars :as vars]
   [lambdaisland.uri :as uri]
   [motorsaif.macros :as macros]
   [clojure.string :as str]))

;; TODO this works for dev but not prod.
(def url-config (vars/inline-env :url))
(def static-path (vars/inline-env :static-path))


;; Define a macro to get the host IP address for CLJ, and a var for CLJS

(defn reverse-geocode-url [api-key {:keys [latitude longitude]}]
  (let [params {:latlng (str latitude "," longitude)
                :key api-key}]
    (str "https://maps.googleapis.com/maps/api/geocode/json?"
         (uri/map->query-string params))))

(defn api [endpoint]
  (if (re-find #"^http" endpoint)
    endpoint
    (let [base-uri (uri/map->URI url-config)
          path (if (.startsWith endpoint "/")
                 endpoint
                 (str "/" endpoint))]
      (str (assoc base-uri :path path)))))

(comment
  (api "https://maps.googleapis.com/maps/api/geocode/json?latlng=25.5026198%2C55.5638099&key=AIzaSyByB4QXFBVCC6eyIzUEhBv3Lm9YMgFBELs")

  (api "test/df"))

(defn uploaded-media [{:keys [media size]
                       :or {size :full}}]
  (assert (#{:med :full} size))
  (let [root-path "/uploads"
        {path :media/path} media

        [path extension] (str/split path #"\.(?=\w{3,4}$)")

        size (condp = size
               :full ""
               :med "_med")

        new-path (str/join "." [(str path size) extension])

        full-path (str root-path "/" new-path)]
    (when media
      full-path)))

#?(:clj
   (do
     (defn static-asset [path]
       (str (uri/join (merge (uri/uri "")
                             url-config)
                      static-path
                      path)))

     (defn from-path [path]
       (str (uri/join (merge (uri/uri "")
                             url-config) path)))))

(defn param-string [url params]
  (str (reduce (fn [acc [k v]]
             (uri/assoc-query acc k v))
           (uri/uri url)
           params)))
